<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h3>Standorte</h3>
      <button @click="$router.push('/locations/add')" type="button" class="btn btn-primary btn-sm d-flex align-items-center">
        <img class="mr-2" src="../../assets/icons/pencil.svg" /> Neuen Standort anlegen
      </button>
    </div>
    <List :columns="columns" :values="locations" :clickable="true" @clicked="$router.push('/locations/' + $event)"  emptyText="Bisher keine Standorte vorhanden">
      <template #column_managers="{data}">
        <div @click.prevent="$router.push('/locations/' + data.id + '/manager')">{{ data.managers }}</div>
      </template>
      <template #column_action="{data}">
        <div class="actions">
          <img @click.prevent="$router.push('/locations/' + data.id + '/manager')" src="../../assets/icons/users.svg" />
          <img @click.prevent="$router.push('/locations/' + data.id)" src="../../assets/icons/settings.svg" />
        </div>
      </template>
      <template #column_createdAt="{data}">{{ data.createdAt | dateFormat }}</template>
    </List>
  </div>
</template>

<script>
import {broadcast} from "@/util/eventHandler.js";
import List from "@/components/partial/List.vue";

export default {
  name: "Locations",
  components: {List},
  data() {
    return {
      columns: [
        { name: "Name", key: "name", styles: { "min-width": "140px" } },
        { name: "Beschreibung", key: "description" },
        { name: "Verwalter", key: "managers", styles: { "min-width": "175px" } },
        { name: "Aktion", key: "action", styles: { width: "100px" } },
        { name: "Erstellt", key: "createdAt", styles: { width: "100px" } }
      ]
    };
  },
  computed: {
    locations() {
      return this.$store.state.locations;
    }
  },
  created() {
    this.loadLocations();
    // this.loadAdmins();
  },
  methods: {
    async loadLocations() {
      console.log("Load locations...");
      try {
        await this.$store.dispatch("FETCH_LOCATIONS");
      } catch (e) {
        broadcast("error", e);
      }
    },
    async loadAdmins() {
      console.log("Load admins...");
      try {
        await this.$store.dispatch("FETCH_ADMINS");
      } catch (e) {
        broadcast("error", e);
      }
    }
  }
};
</script>

<style lang="scss">
.actions {
  display: flex;
  gap: 10px;

  > img:hover {
    cursor: pointer;
  }
}
</style>
